/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Formate the date with the given formate type.
 *
 * @param date The date to be formatted.
 * @param formateType The type of the format, default = 'dd/mm/yyyy'
 */
export const getFormattedDate = (date: Date): string => {
    if (!date) {
        return;
    }

    const day = date.getDate();
    // Note that:getMonth returns the month zero-based.
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};
